import { type ActivityCursor, type ActivityFilters, type ActivityPage } from "../activity";

export const ACTIVITY_REQUEST_TIMEOUT_MS = 15_000;
export class ActivityRequestError extends Error {
  constructor(public accessDenied = false) { super("Não foi possível carregar Activity."); }
}
export async function requestActivity(workspaceId: string, userId: string,
  options: { filters?: ActivityFilters; cursor?: ActivityCursor | null; signal?: AbortSignal } = {},
  request: typeof fetch = fetch,
): Promise<ActivityPage> {
  if (options.signal?.aborted) throw new ActivityRequestError();
  const params = new URLSearchParams({ userId, ...options.filters, ...options.cursor });
  const controller = new AbortController();
  let timer: ReturnType<typeof setTimeout> | undefined;
  let cancel = () => {};
  const interrupted = new Promise<never>((_, reject) => {
    cancel = () => { reject(new ActivityRequestError()); controller.abort(); };
    options.signal?.addEventListener("abort", cancel, { once: true });
    timer = setTimeout(cancel, ACTIVITY_REQUEST_TIMEOUT_MS);
  });
  try {
    return await Promise.race([interrupted, (async () => {
      const response = await request(`/api/workspaces/${encodeURIComponent(workspaceId)}/activity?${params}`, {
        cache: "no-store", signal: controller.signal,
      });
      if (!response.ok) throw new ActivityRequestError(response.status === 401 || response.status === 403);
      const page = await response.json() as ActivityPage;
      if (controller.signal.aborted) throw new ActivityRequestError();
      return page;
    })()]);
  } finally {
    clearTimeout(timer); options.signal?.removeEventListener("abort", cancel);
  }
}
